module.exports = __webpack_public_path__ + "static/graph-curve-5e1203b1772d26eaff86c1c81d8cf759.svg";